export default class OfferingField {
    static fromData(data) {
        if (!data) {
            return;
        }

        let field = new OfferingField();

        field.id = data.id || null;
        field.name = data.name;
        field.note = data.note;
        field.size = data.size;
        field.maxPersons = data.maxPersons;
        field.areaId = data.areaId;
        field.areaName = data.areaName;
        field.locationId = data.locationId;
        field.locationName = data.location.name;
        field.locationStreet = data.locationStreet;
        field.locationAddressCo = data.locationAddressCo;
        field.locationPostalCode = data.locationPostalCode;
        field.locationCity = data.locationCity;
        field.area = data.area;
        field.location = data.location;

        Object.seal(field);
        return field;
    }

    equals(field){
        if (field.id === null) {
            return false;
        }
        return field.id === this.id;
    }
}
